import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5 4C4.44772 4 4 4.44772 4 5V11.1716C4 11.4368 4.10536 11.6911 4.29289 11.8787L12.0429 19.6287C12.4334 20.0192 13.0666 20.0192 13.4571 19.6287L19.6287 13.4571C20.0192 13.0666 20.0192 12.4334 19.6287 12.0429L11.8787 4.29289C11.6911 4.10536 11.4368 4 11.1716 4H5ZM2 5C2 3.34315 3.34315 2 5 2H11.1716C11.9672 2 12.7303 2.31607 13.2929 2.87868L21.0429 10.6287C22.2145 11.8003 22.2145 13.6997 21.0429 14.8713L14.8713 21.0429C13.6997 22.2145 11.8003 22.2145 10.6287 21.0429L2.87868 13.2929C2.31607 12.7303 2 11.9672 2 11.1716V5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9 7.5C9 8.32843 8.32843 9 7.5 9C6.67157 9 6 8.32843 6 7.5C6 6.67157 6.67157 6 7.5 6C8.32843 6 9 6.67157 9 7.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }